export default __webpack_public_path__ + "static/media/hht1_ep1_minisitcom_01.7df0552f.png";